<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
export default {
  name: "App",
  components: {},
  data() {
    return {};
  },
  mounted() {
    if (this.$route.query.courseId != undefined) {
      this.loadData();
    }
  },

  methods: {
    async loadData() {
      this.$store.commit("setCourseIdParam", this.$route.query.courseId);
      this.$store.commit("setTypeParam", this.$route.query.type);
      let course = await axios.get(
        "/app/api/content/course?id=" + this.$route.query.courseId
      );
      this.$store.commit("setVideoContents", course.data.data.videoContentVOS);
      if (this.$route.query.audioId) {
        var audioId = this.$route.query.audioId;
        if (audioId > 122 || audioId < 101) {
          audioId = 101;
        }
        console.log("audio id not null:" + audioId);
        let video = await axios.get(
          "/app/api/content/videoContent?id=" + audioId
        );
        this.$store.commit("setVideoContent", video.data.data);
        let comment = await axios.get(
          "/app/api/content/commentList?pageSize=1000&pageCount=1&contentType=1&id=" +
            this.$route.query.audioId
        );
        this.$store.commit("setComments", comment.data.data.data);
      } else {
        for (const content of course.data.data.videoContentVOS) {
          if (content.freeType != 3) {
            let video = await axios.get(
              "/app/api/content/videoContent?id=" + content.id
            );
            this.$store.commit("setVideoContent", video.data.data);
            let comment = await axios.get(
              "/app/api/content/commentList?pageSize=1000&pageCount=1&contentType=1&id=" +
                content.id
            );
            this.$store.commit("setComments", comment.data.data.data);
            break;
          }
        }
      }

      let courses = await axios.get(
        "/app/api/content/teamCourseList?id=" + this.$route.query.courseId
      );
      this.$store.commit("setCourses", courses.data.data);
    },
  },
};
</script>
<style>
.prism-player .prism-big-play-btn {
  left: 25px !important;
  bottom: 5px !important;
  width: 64px !important;
  height: 64px !important;
  opacity: 0;
}
.prism-player .prism-big-play-btn .outter,
.prism-animation.prism-play-animation.play-apply-animation,
.prism-animation {
  display: none !important;
}
#app {
  width: 100%;
  height: 100%;
}
.cutText span {
  color: #ffffff;
}
.cutText .cutTextSpan {
  display: inline-block;
  width: 100%;
  height: 100%;
  margin-top: 440px;
}
.cutText .cutTextSpan p {
  display: inline-block;
  font-size: 40px;
  font-weight: 400;
  color: #ffffff;
  line-height: 72px;
}
.cutText .cutTextSpan h3 {
  display: inline-block;
  margin-top: 40px;
  font-size: 96px;
  font-weight: 600;
  color: #ffffff;
  line-height: 72px;
}
.redColor {
  color: #fe5838;
  font-size: 26px;
}
</style>
